import TreebankStyles from './TreebankStyles';

export default TreebankStyles;
